import React from "react";
import { format } from "date-fns";

export interface DateViewProps {
    value: Date;
}

const DateView:React.FC<DateViewProps> = ({ value }) => (<span>{format(value, 'yyyy-MM-dd')}</span>)

export default DateView;